import { ExteriorGrades } from './ExteriorGrades';
import { MechanicalGrades } from './MechanicalGrades';
import { InteriorGrades } from './InteriorGrades';

type Props = {
  section: string;
};

export const GradePercentage = ({ section }: Props) => {
  if (section === 'exterior') return <ExteriorGrades />;
  if (section === 'mechanical') return <MechanicalGrades />;
  if (section === 'interior') return <InteriorGrades />;

  return null;
};
